/*
  Behavior port of the user's own Energy landing page mockup:
  scroll-reveal, gallery (arrows/thumbs/swipe/keyboard), pack-radio <->
  gallery two-way sync, formula ingredient accordion -> image swap, and
  real add-to-cart via Shopify's native /cart/add.js.
*/
(function () {
  "use strict";

  function init(root) {
    root.classList.add("js");

    // ---- Scroll reveal ---------------------------------------------------
    var shopSec = root.querySelector(".shop-sec");
    requestAnimationFrame(function () {
      root.querySelectorAll(".shop-sec .r").forEach(function (el) { el.classList.add("in"); });
    });
    var targets = [].filter.call(root.querySelectorAll(".r"), function (el) {
      return !shopSec || !shopSec.contains(el);
    });
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add("in"); io.unobserve(entry.target); }
        });
      }, { rootMargin: "0px 0px 200px 0px", threshold: 0 });
      targets.forEach(function (el) { io.observe(el); });
    }

    // ---- Gallery: arrows, thumbs, swipe, keyboard -------------------------
    var thumbs = [].slice.call(root.querySelectorAll('[data-v2g-e-thumbs] [data-v2g-e-thumb]'));
    var track = root.querySelector('[data-v2g-e-track]');
    var goGallery = function () {};
    if (track) {
      var slides = track.children.length, i = 0;
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = "translateX(" + (-i * 100) + "%)";
        thumbs.forEach(function (b, x) { b.setAttribute("aria-current", x === i ? "true" : "false"); });
      }
      goGallery = go;
      var prevBtn = root.querySelector('[data-v2g-e-prev]');
      var nextBtn = root.querySelector('[data-v2g-e-next]');
      if (prevBtn) prevBtn.addEventListener("click", function () { go(i - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { go(i + 1); });
      thumbs.forEach(function (b, x) { b.addEventListener("click", function () { go(x); }); });

      var stage = root.querySelector('[data-v2g-e-stage]');
      if (stage) {
        stage.setAttribute("tabindex", "0");
        stage.addEventListener("keydown", function (e) {
          if (e.key === "ArrowLeft") { e.preventDefault(); go(i - 1); }
          if (e.key === "ArrowRight") { e.preventDefault(); go(i + 1); }
        });
        var x0 = null;
        stage.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener("touchend", function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }
    }

    // ---- Pack <-> gallery sync ---------------------------------------------
    var packInputs = [].slice.call(root.querySelectorAll('input[name="v2g-e-pack"]'));
    var variantInput = root.querySelector('[data-v2g-e-variant-id]');
    var priceEl = root.querySelector('[data-v2g-e-price]');
    var priceSubEl = root.querySelector('[data-v2g-e-price-sub]');

    function updatePack(syncGallery) {
      var selected = root.querySelector('input[name="v2g-e-pack"]:checked');
      if (!selected) return;
      if (variantInput) variantInput.value = selected.value;
      if (priceEl) priceEl.innerHTML = selected.dataset.price + ' <span class="note">' + selected.dataset.note + "</span>";
      if (priceSubEl) priceSubEl.textContent = selected.dataset.sub || "";
      if (syncGallery !== false) {
        var slide = parseInt(selected.dataset.slide || "0", 10);
        if (!isNaN(slide)) goGallery(slide);
      }
    }
    packInputs.forEach(function (input) {
      input.addEventListener("change", function () { updatePack(true); });
    });
    thumbs.forEach(function (b, x) {
      b.addEventListener("click", function () {
        if (packInputs[x]) { packInputs[x].checked = true; updatePack(false); }
      });
    });
    updatePack(true);

    // ---- Formula ingredient accordion -> image swap ------------------------
    var formulaVisual = root.querySelector('[data-v2g-e-formula-img]');
    var formulaDetails = [].slice.call(root.querySelectorAll('[data-v2g-e-formula] details[data-ingredient]'));
    var formulaMap = {};
    if (formulaVisual && formulaVisual.dataset.map) {
      try { formulaMap = JSON.parse(formulaVisual.dataset.map); } catch (e) { formulaMap = {}; }
    }
    function setFormulaVisual(key) {
      if (!formulaVisual) return;
      formulaVisual.style.opacity = "0";
      formulaVisual.style.transform = "scale(.985)";
      setTimeout(function () {
        formulaVisual.src = formulaMap[key] || formulaMap.guarana;
        formulaVisual.style.opacity = "1";
        formulaVisual.style.transform = "scale(1)";
      }, 120);
    }
    if (formulaDetails.length) {
      formulaDetails.forEach(function (det) {
        det.addEventListener("toggle", function () {
          if (det.open) {
            formulaDetails.forEach(function (other) { if (other !== det) other.open = false; });
            setFormulaVisual(det.dataset.ingredient);
          }
        });
      });
      var active = formulaDetails.filter(function (det) { return det.open; })[0];
      setFormulaVisual(active ? active.dataset.ingredient : "guarana");
    }

    // ---- Quantity stepper ----------------------------------------------------
    var qtyValueEl = root.querySelector('[data-v2g-e-qty-value]');
    var qtyDecBtn = root.querySelector('[data-v2g-e-qty-decrease]');
    var qtyIncBtn = root.querySelector('[data-v2g-e-qty-increase]');
    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyValueEl) qtyValueEl.textContent = qty;
    }
    if (qtyDecBtn) qtyDecBtn.addEventListener("click", function () { setQty(qty - 1); });
    if (qtyIncBtn) qtyIncBtn.addEventListener("click", function () { setQty(qty + 1); });

    // ---- Add to cart (Shopify native AJAX Cart API) -------------------------
    var addBtn = root.querySelector('[data-v2g-e-add]');
    if (addBtn && variantInput) {
      addBtn.addEventListener("click", function () {
        var selected = root.querySelector('input[name="v2g-e-pack"]:checked');
        if (!selected || !variantInput.value) return;
        var oldLabel = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = "Toevoegen…";

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variantInput.value, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent("vit2go:cart:updated", { detail: cart }));
            addBtn.textContent = "Toegevoegd: " + (selected.dataset.added || selected.dataset.name || selected.value);
            setQty(1);
          })
          .catch(function () {
            addBtn.textContent = "Er ging iets mis — probeer opnieuw";
          })
          .finally(function () {
            setTimeout(function () { addBtn.textContent = oldLabel; addBtn.disabled = false; }, 1600);
          });
      });
    }

    // ---- Equalize pack-card heights (CSS Grid sizes each row by its own
    // content, so shorter text in one row leaves it shorter than a row
    // whose title/subtitle happens to wrap) ---------------------------------
    var boxes = [].slice.call(root.querySelectorAll(".opt-grid .opt .box"));
    if (boxes.length) {
      var equalize = function () {
        boxes.forEach(function (b) { b.style.minHeight = ""; });
        var max = boxes.reduce(function (m, b) { return Math.max(m, b.getBoundingClientRect().height); }, 0);
        boxes.forEach(function (b) { b.style.minHeight = max + "px"; });
      };
      equalize();
      var resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalize, 150);
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-v2g-energy]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
